import React, { useState, useEffect } from 'react'
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import { useLocation } from 'react-router-dom';
import TopSubMenuAboutUs from '../ServiceDetailsLevel2/TopSubMenuAboutUs';
import PinnedBlog from '../NewsAndSearch/PinnedBlog';
import { OurStoriesPageResponse } from '../../../Service/OurStories';
import { OUR_STORIES_PAGE_URL } from '../../../common/APi/apiurl';
import { formatOurStoriesHeader, formatOurStoriesGetToKnow, formatOurStoriesStoriesCard } from "../../../common/utils/utils";
import OurStoriesHeader from './OurStoriesHeader';
import OurStoriesGetToKnow from './OurStoriesGetToKnow';
import { Grid } from '@mui/material';
import NoResultFound from '../NewsAndSearch/NoResultFound';
import CommonStories from './CommonStories';

const OurStories = () => {
    const location = useLocation().pathname;
    const [loading, setLoading] = useState<boolean>(true);
    const [pageContent, setContent] = useState<null | any>(null);
    const [HeaderDetail, setHeaderData] = useState<null | any>(null);
    const [GetToKnowDetail, setGetToKnowData] = useState<null | any>(null);
    const [StoriesCard, setStoriesCard] = useState<null | any>(null);
    const currentPage = location;

    const fetchResponse = async () => {
        try {
            // Fetch header content
            const response = await OurStoriesPageResponse(OUR_STORIES_PAGE_URL);
            setContent(response);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching data:', error);
            setLoading(false);
        }
    };

    const formatData = () => {
        let HeaderData;
        let GetToKnowData;
        let StoriesCardData;
        if (pageContent) {
            HeaderData = formatOurStoriesHeader(pageContent);
            GetToKnowData = formatOurStoriesGetToKnow(pageContent);
            StoriesCardData = formatOurStoriesStoriesCard(pageContent);
            setHeaderData(HeaderData);
            setGetToKnowData(GetToKnowData);
            setStoriesCard(StoriesCardData);
        }
    }

    useEffect(() => {
        window.scrollTo(0, 0);
        fetchResponse();
    }, [location]);
    useEffect(() => {
        formatData();
    }, [pageContent])

    const pinnedStories = StoriesCard?.filter((story: any) => story.field_is_pinned === "true") || [];
    const commonStories = StoriesCard?.filter((story: any) => story.field_is_pinned === "false") || [];

    return (
        <>
            {loading ? <h1 style={{ display: 'none' }}>Loading....</h1> :
                <React.Fragment>
                    <TopSubMenuAboutUs currentPage={"/ourStories"} />
                    <OurStoriesHeader data={HeaderDetail} />

                    {/* Content Section */}
                    <Box className='our-stories' pt={{ xs: "30px", lg: "77px" }}>
                        <Container maxWidth={false} sx={{ maxWidth: '1332px' }}>
                            <OurStoriesGetToKnow data={GetToKnowDetail} />

                            {/* Pinned Blog Section */}
                            <PinnedBlog
                                data={pinnedStories}
                                topicSearched=""
                                typeSearched=""
                                textSearched=""
                                currentPage={1}
                                routePrefix="/StoryDetails"
                            />

                            <Grid
                                container
                                spacing={4}
                                sx={{
                                    mb: { xs: 8, md: 12 },
                                    position: 'relative'
                                }}
                            >
                                {commonStories.length > 0 ?
                                    <CommonStories data={commonStories} /> :
                                    <Grid item xs={12} >
                                        <NoResultFound />
                                    </Grid>
                                }
                            </Grid>
                        </Container>
                    </Box>
                </React.Fragment>
            }
        </>
    );
}

export default OurStories;





